import { createReducer, on } from '@ngrx/store';
import { configInitialState } from './config.types';
import {
  setDebtsError,
  setIsContractAccountConsult,
  setLoadingActive,
  setLoadingDisabled,
  setOrderStatus,
  setOrigin,
  setReceiptType,
  setCanReturnToCheckout,
  setRoutePermissions,
  setLoadingContent,
  setLoading,
} from './config.actions';
import { produce } from 'immer';
import {
  DEFAULT_SPINNER_LOADING,
  LoadingIdsEnum,
  LoadingTypeEnum,
} from 'src/app/models/loading.model';

export const configReducer = createReducer(
  configInitialState,

  on(setLoadingActive, (state, config) =>
    produce(state, (draft) => {
      if (config.loadingConfig.content) {
        draft.loadingConfig = config.loadingConfig || DEFAULT_SPINNER_LOADING;
      } else {
        draft.loadingConfig = { ...config.loadingConfig, content: DEFAULT_SPINNER_LOADING.content };
      }
      draft.loading = true;
    })
  ),

  on(setLoading, (state, loading) =>
    produce(state, (draft) => {
      draft.loading = loading.loading;
    })
  ),

  on(setLoadingContent, (state, config) =>
    produce(state, (draft) => {
      draft.loading = true;
      draft.loadingConfig.content = config.content;
    })
  ),
  on(setLoadingDisabled, (state) =>
    produce(state, (draft) => {
      draft.loading = false;
      draft.loadingConfig = {
        id: LoadingIdsEnum.SPINNER,
        type: LoadingTypeEnum.DefaultBackground,
      };
    })
  ),

  on(setDebtsError, (state, error) =>
    produce(state, (draft) => {
      draft.debtsError = error.error;
    })
  ),

  on(setIsContractAccountConsult, (state, isContractAccountConsult) =>
    produce(state, (draft) => {
      draft.isContractAccountConsult = isContractAccountConsult.isContractAccountConsult;
    })
  ),

  on(setOrderStatus, (state, order) =>
    produce(state, (draft) => {
      draft.orderStatus = order.orderStatus;
    })
  ),

  on(setReceiptType, (state, receipt) =>
    produce(state, (draft) => {
      draft.receiptType = receipt.receiptType;
    })
  ),

  on(setOrigin, (state, origin) =>
    produce(state, (draft) => {
      draft.origin = origin.origin;
    })
  ),

  on(setRoutePermissions, (state, { routePermissions }) =>
    produce(state, (draft) => {
      draft.routePermissions = routePermissions;
    })
  ),

  on(setCanReturnToCheckout, (state, returnToCheckout) =>
    produce(state, (draft) => {
      draft.canReturnToCheckout = returnToCheckout.canReturnToCheckout;
    })
  )
);
